import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ImageResize from './imageResize';

export default function ToolsRoutes({ match }) {
  return (
    <Switch>
      <Route path={`${match.url}/image-resize`} component={ImageResize} />
    </Switch>
  );
}
